import { RootState } from 'store';

import { STATE } from '../types/state';

const selector = (state: RootState) => {
  const { fitBounds } = state[STATE].actionStations;
  return fitBounds;
};

export default selector;
